import { render, staticRenderFns } from "./Complaints.vue?vue&type=template&id=19e2fdce&scoped=true&"
import script from "./Complaints.vue?vue&type=script&lang=js&"
export * from "./Complaints.vue?vue&type=script&lang=js&"
import style0 from "./Complaints.vue?vue&type=style&index=0&id=19e2fdce&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e2fdce",
  null
  
)

export default component.exports